import { DeleteButton } from "@/components/DeleteButton";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useRemoveContractorAssignmentMutation } from "../hooks/useRemoveContractorAssignmentMutation";
import { useFormContext } from "react-hook-form";

interface ContractorsAssignmentsRemoveButton {
  assignmentId: string;
  className?: string;
}

export const ContractorsAssignmentsRemoveButton = ({
  assignmentId,
  className,
}: ContractorsAssignmentsRemoveButton) => {
  const { t } = useTranslation();
  const removeMutation = useRemoveContractorAssignmentMutation();
  const { formState } = useFormContext();

  const onRemove = useCallback(() => {
    removeMutation.mutateAsync(assignmentId);
  }, [assignmentId, removeMutation]);

  return (
    <DeleteButton
      variant="ghost"
      onClick={onRemove}
      label={t("contractorsAssignments.removeRow")}
      className={className}
      disabled={formState.disabled}
    />
  );
};
